import React from 'react';
import { Carousel } from 'components/Carousel';
import { colors, FlexCenter, Container } from 'globalStyle';
import styled from 'styled-components';
import { Project, LoadingProject } from 'components/Cards/components/Project';

const settings = {
  dots: false,
  lazyLoad: true,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const ListOfProjectComponent = ({ isLoading, projects = [] }) => {
  if (isLoading) {
    return <Loading />;
  }

  return (
    <div>
      <Container>
        <Carousel {...settings}>
          {
            projects.map((project) => (
              <Project
                key={project.id}
                project={project}
              />
            ))
          }
        </Carousel>
      </Container>
    </div>
  );
};

const Loading = () => (
  <div>
    <Container>
      <Carousel {...settings}>
        {[...new Array(4).keys()].map((index) => <LoadingProject key={index} />)}
      </Carousel>
    </Container>
  </div>
);

export const Arrows = styled.div`
    ${FlexCenter}
    justify-content: center;
    margin-top: 1em;

    svg{
        color: ${colors.GRAY_2};
        width: 1.2em;
        height: 1.2em;
        cursor: pointer;
        margin-right: 2em;
    }
`;

export const ListOfProject = React.memo(ListOfProjectComponent);
